import React from 'react';
import VIPBadge from '../../VipBadge';

export default function VipBenefits() {
  const tiers = [
    { name: 'Lunar Initiate', validityFree: 15, price: 149, validityPaid: 30, color:'#8b5cf6', key:'vip1' },
    { name: 'Pixel Guardian', validityFree: 45, price: 399, validityPaid: 90, color:'#3b82f6', key:'vip2' },
    { name: 'Celestial Overload', validityFree: 180, price: 999, validityPaid: 365, color:'#f59e0b', key:'vip3' }
  ];

  return (
    <div style={{ padding: 20 }}>
      <h2>VIP Benefits</h2>
      {tiers.map(t => (
        <div key={t.key} style={{ border: '1px solid #eee', padding: 12, marginBottom: 12 }}>
          <div style={{ display:'flex', justifyContent:'space-between' }}>
            <div><h3>{t.name}</h3><div>Free validity: {t.validityFree} days</div><div>Paid: ₹{t.price} for {t.validityPaid} days</div></div>
            <VIPBadge text={t.name} color={t.color} />
          </div>
          <div style={{ marginTop: 8 }}>
            <ul>
              <li>Exclusive discounts on bundles</li>
              <li>Priority support</li>
              <li>Early access to offers</li>
              <li>Extra discounts on Game Accounts</li>
            </ul>
          </div>
        </div>
      ))}
    </div>
  );
}
